import { render, staticRenderFns } from "./file-confirm-modal.vue?vue&type=template&id=0a8604e9&scoped=true"
import script from "./file-confirm-modal.vue?vue&type=script&lang=js"
export * from "./file-confirm-modal.vue?vue&type=script&lang=js"
import style0 from "./file-confirm-modal.vue?vue&type=style&index=0&id=0a8604e9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8604e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a8604e9')) {
      api.createRecord('0a8604e9', component.options)
    } else {
      api.reload('0a8604e9', component.options)
    }
    module.hot.accept("./file-confirm-modal.vue?vue&type=template&id=0a8604e9&scoped=true", function () {
      api.rerender('0a8604e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/file-confirm-modal.vue"
export default component.exports